import App from "./App.svelte";

const app = new App();

export default app;